import { buyBundle, recharge } from "../routes/routeConstants"

export const eventCategory = {
  CASH_WITHDRAW: "Cash Withdraw",
  AIRTIME_LOAN: "airtime-loan",
  LANDING_PAGE: "landing_page",
  TECH_EVENT: "tech_event",
  QSG: "qsg",
  LOGIN: "login",
  BUY_GOODS: "buy_goods",
  SECURE_SMS: "secure-sms",
  PAYBILL: "paybill",
  NETWORK_TYPE: "network_type",
  APP_INFO: "app_info",
  HE_LOGIN: "he_login",
  COMPATIBILITY: "compatibility",
  BUY_AIRTIME: "buy_airtime",
  BUY_BUNDLE: "buy_bundle",
  SEND_MONEY: "send_money",
  WITHDRAW_CASH: "cash_withdraw",
  FORGOT_NUMBER: "forgot_number",
  DASHBOARD: "dashboard",
  PAY_OPTIONS:"pay options"
}

export const eventAction = {
  CASH_OUT_VALID_AGENT_CODE: "wdrawcash_agentid_authenticate_valid",
  CASH_OUT_INVALID_AGENT_CODE: "wdrawcash_agentid_authenticate_wrong",
  VERIFY_PIN_BOTTOM_SCREEN: "verify_pin_bottom_screen",
  CONFIRMATION_SCREEN_CONFIRM_TAPPED: "wdrawcash_trxscreen_continue_clicked",
  TRANSACTION_FEES_API_INITIATED: "transaction_fees_api_initiated",
  CASH_WITHDRAWAL_AGENT_SUCCESS: "wdrawcash_trxsuccess",
  CASH_WITHDRAWAL_AGENT_FAILED: "wdrawcash_trxfailed",
  CASH_WITHDRAWAL_AGENT_INITIATED: "wdrawcash_ampin_entered",
  CASH_OUT_AGENT_SCREEN_NEXT_TAPPED: "wdrawcash_next_clicked",
  CONFIRMATION_SCREEN_CANCEL_TAPPED: "confirmation_screen_cancel_tapped",
  TRANSACTION_FAILED_INSUFFICIENT_BALANCE: "wdrawcash_trxfailed_insufficient_balance",
  TRANSACTION_FAILED_INVALID_MSISDN: "wdrawcash_trxfailed_invalid_msisdn",
  AMOUNT_ENTERED: "wdrawcash_amountentered",
  TRANSACTION_LIMIT_BREACHED: "wdrawcash_amount_trxlimit_breached",
  TRANSACTION_FAILED_INCORRECT_PIN: "wdrawcash_trxfailed_incorrect_pin"
}

export const pinMgmtEvents = {
  [buyBundle.BUNDLE_MENU]: "setpin_buy_bundle_clicked",
  [recharge.RECHARGE]: "setpin_airtime_recharge_clicked",
  "": "setpin_homescr_clicked"
}

export const securityQuestionEvents = {
  [buyBundle.BUNDLE_MENU]: "setsecurityqn_buy_bundle_clicked",
  [recharge.RECHARGE]: "setsecurityqn_airtime_recharge_clicked",
  "": "setsecurityqn_homescr_clicked"
}

export const SEND_MONEY_EVENTS = {
  SEND_MONEY: "send-money",
  SEND_MONEY_: "send_money_",
  SNDMON: "sndmon_",
  LOCAL: "_local_",
  SEND_MONEY_P2P_LOCAL_: "sndmon_p2p_local_",
  OPTR_SELECTED: "operatorselected",
  SELECTED_OPTR: "operatorselect_",
  NUM_ENTERED: "num_entered",
  NUM_ENTERED_CRCT: "num_entered_crct",
  NUM_ENTERED_WRNG: "num_entered_wrong",
  TRX_LIMIT_BREACH: "trxlimit_breach",
  TRX_SUCCESS: "trxsuccess",
  TRX_FAIL: "trxfail",
  TRX_FAIL_INCRT_PIN: "trxfail_incorrect_pin",
  TRX_FAIL_INSUFFICIENT_BAL: "trxfail_insufficient_bal",
  AM_PIN_POPUP: "am_pin_popup",
  AM_PIN_ENTERED: "ampin_entered",
  REASON_ENTERED: "reasonentered",
  AMT_ENTERED: "amountentered",
  NXT_CLICKED: "next_clicked",
  PURPOSE_SELECTED: "purposeselected",
  SEND_MONEY_TXN_FEES_API_SUCCESS: "send_money_txn_fees_api_success",
  REC_NAME_ENTERED: "recname_entered",
  SEND_MONEY_TXN_FEES_API_FAIL: "send_money_txn_fees_api_fail",
  SEND_MONEY_TXN_DETAILS_CONTINUE_CLICK: "_txndetails_continue_click",
  SEND_MONEY_TXN_DETAILS_CLOSE_CLICK: "_txn_details_close_click",
  SEND_MONEY_NEXT_CLICKED: "_next_click",
  SEND_MONEY_INIT: "send_money_init",
  SEND_MONEY_FINISH: "send_money_finish",
  SEND_MONEY_SUCCESS: "send_money_success",
  SEND_MONEY_FAILED: "send_money_failed"
}

export const SET_QUESTION_EVENTS = {
  SET_QUESTION: "set_question",
  SET_SECURITY_QNS_QN_SELECTED: "setsecurityqn_qnselected",
  SET_SECURITY_QN_FAIL: "setsecurityqn_fail",
  SET_SECURITY_QN_SUCCESS: "setsecurityqn_success",
  SET_SECURITY_QN_RESPONSE_ADDED: "setsecurityqn_response_added"
}

export const MANAGE_QUESTION_EVENTS = {
  MANAGE_QUESTION: "manageQuestion",
  MANAGE_SECURITY_QUESTION_SEC_QN_SCREEN_VIEWED: "managesecqn_secqnscr_viewed",
  MANAGE_SECURITY_QUESTION_QN_SELECTED: "managesecurityqn_qnselected",
  MANAGE_SECURITY_QUESTION_PIN_INPUT_DONE: "managesecurityqn_pin_input_done",
  MANAGE_SECURITY_QUESTION_PIN_INPUT_INCORRECT: "managesecurityqn_pin_input_incorrect",
  MANAGE_SECURITY_QUESTION_FAIL: "managesecurityqn_fail",
  MANAGE_SECURITY_QUESTION_SUCCESS: "managesecurityqn_success",
  MANAGE_SECURITY_QUESTION_PIN_INPUT_CORRECT: "managesecurityqn_pin_input_correct",
  MANAGE_SECURITY_QUESTION_AM_PIN_INPUT_SCREEN_VIEWED: "managesecqn_ampininputscr_viewed",
  MANAGE_SECURITY_QUESTION_SAVE_CLICKED: "managesecurityqn_save_clicked",
  MANAGE_SECURITY_QUESTION_RESPONSE_ADDED: "managesecurityqn_response_added"
}

export const BUY_AIRTIME_EVENTS = {
  BUY_AIRTIME: "buy-airtime",
  PAYMENT_MODE_SELECTED_AM: "buy_airtime_paymentmodeselected_am",
  PAYMENT_SUCCESSFUL_SELF: "buyairtime_paymentsuccess_self",
  PAYMENT_SUCCESSFUL_OTHERS: "buyairtime_paymentsuccess_others",
  PAYMENT_SUCCESSFUL: "buyairtime_paymentsuccessful",
  PAYMENT_SUCCESSFUL_AM: "buy_airtime_paymentsuccessful_am",
  GUEST_PAYMENT_SUCCESSFUL_AM_: "g_buy_airtime_paymentsuccessful_am_",
  TRNX_LIMIT_BREACH: "buy_airtime_rechothers_trxlimitbreach",
  PAYMENT_FAIL_AM_INCORRECT_PIN: "buy_airtime_pymtfail_am_incorrectpin",
  PAYMENT_FAIL_AM_INSUFFICIENT_BALANCE: "buy_airtime_pymtfail_am_lowbalance",
  PAYMENT_FAIL_AM_OTHERS: "buy_airtime_pymtfail_am_others",
  PAYMENT_FAIL: "buyairtime_paymentfailed",
  PAYMENT_FAILED_AM: "buy_airtime_paymentfailed_am",
  GUEST_PAYMENT_FAILED_AM_: "g_buy_airtime_paymentfailed_am_",
  BUY_AIRTIME_INIT: "buy_airtime_init",
  BUY_AIRTIME_GUEST_INIT: "g_buy_airtime_init",
  BUY_AIRTIME_FINISH: "buy_airtime_finish",
  BUY_AIRTIME_GUEST_FINISH: "g_buy_airtime_finish",
  BUY_AIRTIME_SUCCESS: "buy_airtime_success",
  BUY_AIRTIME_GUEST_SUCCESS: "g_buy_airtime_success",
  BUY_AIRTIME_FAILED: "buy_airtime_failed",
  BUY_AIRTIME_GUEST_FAILED: "g_buy_airtime_paymentfailed",
  AIRTIME_PAYMENT_MODE_SELECTED:"buy_airtime_paymentmodeselected_any",
  PAY_OPTIONS_NA:"buy_airtime_pay_options_valid_not_available",
  PAY_OPTIONS__OTHER_NA:"buy_airtime_addnl_pay_options_valid_not_available",
  AM_PIN_ENTERED: "buyairtime_am_pin_entered",
  GUEST_AM_MSISDN_ENTERED: "g_buyairtime_am_msisdn_entered",
  GUEST_AM_CONTINUE_CLICKED: "g_buyairtime_am_continue_clicked",
  GUEST_AIRTIME_CONTINUE_CLICKED: "g_buyairtime_airtime_continue_clicked",
  GUEST_AM_PUSH_SCREEN_VIEWED: "g_buyairtime_am_push_screen_viewed",
  GUEST_PAYMENT_FAIL_AM_LOW_BALANCE: "g_buyairtime_pymtfail_am_lowbal",
  POPULAR_RECHARGE_CLICK: "popular_recharge_click",
  GUEST_PYMT_FAIL_AM_OTHERS: "g_buy_airtime_pymtfail_am_others",
  PAYMENT_MODE_SELECTED: "buyairtime_paymentmodeselected",
  GUEST_AIRTIME_MSISDN_ENTERED: "g_buyairtime_airtime_msisdn_entered",
  GUEST_PAYMENT_FAIL_AM_INCORRECT_PIN: "g_buy_airtime_pymtfail_am_incorrectpin",
  GUEST_TRNX_LIMIT_BREACH: "g_buy_airtime_rechothers_trxlimitbreach",
}

export const BUY_BUNDLE_EVENTS = {
  BUY_BUNDLE: "buy-bundle",
  PAYMENT_MODE_SELECTED_AM: "buy_bndl_paymentmodeselected_am",
  GUEST_PAYMENT_SUCCESSDUL: "g_buy_bndl_payment_successful",
  PAYMENT_SUCCESSFUL_AM: "buy_bndl_paymentsuccessful_am",
  GUEST_PAYMENT_SUCCESSFUL_AM: "g_buy_bndl_paymentsuccessful_am",
  PAYMENT_SUCCESSFUL_AIRTIME: "buybndl_paymentsuccessful_airtime",
  GUEST_PAYMENT_SUCCESSFUL_AIRTIME: "g_buy_bndl_paymentsuccessful_airtime",
  PAYMENT_SUCCESSFUL_MPESA: "buy_bndl_paymentsuccessful_mpesa",
  GUEST_PAYMENT_SUCCESSFUL_MPESA: "g_buy_bndl_paymentsuccessful_mpesa",
  PAYMENT_SUCCESSFUL: "buybndl_paymentsuccessful",
  PAYMENT_SUCCESSFUL_SELF: "buybndl_paymentsuccessful_self",
  PAYMENT_SUCCESSFUL_OTHERS: "buybndl_paymentsuccessful_others",
  PAYMENT_FAILED: "buybndl_paymentfailed",
  GUEST_PAYMENT_FAILED: "g_buy_bndl_paymentfailed",
  PAYMENT_FAILED_AM: "buy_bndl_paymentfailed_am",
  PAYMENT_FAILED_AIRTIME: "buybndl_paymentfailed_airtime",
  PAYMENT_FAILED_MPESA: "buy_bndl_paymentfailed_mpesa",
  GUEST_PAYMENT_FAILED_MPESA: "g_buy_bndl_paymentfailed_mpesa",
  BUY_BUNDLE_INIT: "buy_bndl_init",
  BUY_BUNDLE_GUEST_INIT: "g_buy_bndl_init",
  BUY_BUNDLE_FINISH: "buy_bndl_finish",
  BUY_BUNDLE_GUEST_FINISH: "g_buy_bndl_finish",
  BUY_BUNDLE_SUCCESS: "buy_bndl_success",
  BUY_BUNDLE_GUEST_SUCCESS: "g_buy_bndl_success",
  BUY_BUNDLE_FAILED: "buy_bndl_failed",
  BUY_BUNDLE_GUEST_FAILED: "g_buy_bndl_failed",
  BUNDLE_PAYMENT_MODE_SELECTED:"buybndl_paymentmodeselected_any",
  GUEST_AM_MSISDN_ENTERED: "g_buybndl_am_msisdn_entered",
  GUEST_AIRTIME_MSISDN_ENTERED: "g_buybndl_airtime_msisdn_entered",
  GUEST_AM_CONTINUE_CLICKED: "g_buybndl_am_continue_clicked",
  GUEST_AIRTIME_CONTINUE_CLICKED: "g_buybndl_airtime_continue_clicked",
  GUEST_PAYMENT_FAILED_AM_LOW_BALANCE: "g_buy_bndl_paymentfailed_am_lowbal",
  GUEST_PYMT_FAIL_AM_OTHERS: "g_buy_bndl_pymtfail_am_others",
  AM_PIN_ENTERED: "buy_bndl_am_pin_entered",
  PAYMENT_FAIL_AM_WRONG_PIN: "buy_bndl_paymentfailed_am_wrongpin",
  GUEST_PAYMENT_FAIL_AM_WRONG_PIN: "g_buy_bndl_paymentfailed_am_wrongpin",
  GUEST_PAYMENT_FAILED_AM: "g_buy_bndl_paymentfailed_am",
  PAYMENT_MODE_SELECTED: "buybndl_paymentmodeselected"
}

export const TECH_EVENTS = {
  TE_he_login_redirected_fail: "TE_he_login_redirected_fail",
  TE_he_login_component_mounted: "TE_he_login_component_mounted",
  TE_he_login_wifi_on_render: "TE_he_login_wifi_on_render",
  TE_he_login_other_error_render: "TE_he_login_other_error_render",
  TE_he_unsupported_browser_render: "TE_he_unsupported_browser_render",
  TE_he_retry: "TE_he_retry",
  TE_he_another_method_click: "TE_he_another_method_click",
  TE_low_airtime_balance: "TE_low_airtime_balance",
  TE_low_data_balance: "TE_low_data_balance",
  TE_low_sms_balance: "TE_low_sms_balance",
  TE_low_voice_offnet_balance: "TE_low_voice_offnet_balance",
  TE_low_voice_onnet_balance: "TE_low_voice_onnet_balance",
  TE_low_am_balance: "TE_low_am_balance",
  TE_send_money_p2pi_local_success: "TE_send_money_p2pi_local_success",
  TE_send_money_p2pi_local_failed: "TE_send_money_p2pi_local_failed",
  TE_send_money_p2pi_am_pin_entered: "TE_send_money_p2pi_am_pin_entered",
  TE_send_money_p2pi_local_trx_fail_incrt_pin: "TE_sendmoney_p2pi_localtrx_fail_incorpin",
  TE_send_money_p2pi_local_trx_fail_insufficient_bal: "TE_sendmoney_p2pi_localtrx_fail_lowbal",
  TE_send_money_p2p_local_success: "TE_send_money_p2p_local_success",
  TE_send_money_p2p_local_failed: "TE_send_money_p2p_local_failed",
  TE_send_money_p2p_am_pin_entered: "TE_send_money_p2p_am_pin_entered",
  TE_send_money_p2p_local_trx_fail_incrt_pin: "TE_sendmoney_p2p_localtrx_fail_incorpin",
  TE_send_money_p2p_local_trx_fail_insufficient_bal: "TE_sendmoney_p2p_localtrx_fail_lowbal",
  TE_verify_otp_click: "TE_verify_otp_click",
  TE_verify_otp_success: "TE_verify_otp_success",
  TE_verify_otp_failed: "TE_verify_otp_failed",
  TE_resend_otp_success: "TE_resend_otp_success",
  TE_resend_otp_failed: "TE_resend_otp_failed",
  TE_otp_max_attempts_exausted: "TE_otp_max_attempts_exausted",
  TE_secure_sms_login_screen_viewed: "TE_secure_sms_login_screen_viewed",
  TE_secure_sms_proceedclicked: "TE_secure_sms_proceedclicked",
  TE_secure_sms_sent: "TE_secure_sms_sent",
  TE_secure_sms_polling_started: "TE_secure_sms_polling_started",
  TE_secure_sms_received: "TE_secure_sms_received",
  TE_secure_sms_timeout: "TE_secure_sms_timeout",
  TE_secure_sms_msisdn_mismatch: "TE_secure_sms_msisdn_mismatch",
  TE_secure_sms_msisdn_locked: "TE_secure_sms_msisdn_locked",
  TE_secure_sms_message_edited: "TE_secure_sms_message_edited",
  TE_CASH_OUT_INVALID_AGENT_CODE: "TE_cash_out_invalid_agent_code",
  TE_INVALID_TILL_NO: "TE_invalid_till_no",
  TE_SHARE_SCREENSHOT_CLICKED: "TE_share_screenshot_clicked",
  TE_SHARE_SCREENSHOT_SUCCESS: "TE_share_screenshot_success",
  TE_SHARE_SCREENSHOT_FAILED: "TE_share_screenshot_failed",
  TE_TRANSACTION_LIMIT_ERR_LINK_CLICKED: "TE_transaction_limit_err_link_clicked",
  TE_API_TIMEOUT_FAILURE: "TE_api_timeout_failure"
}

export const QSG_EVENTS = {
  QSG_MOUNTED: "qsg_mounted",
  QSG_NEXT_CLICKED: "qsg_next_clicked",
  QSG_WELCOME_VIEWED: "qsg_welcome_viewed",
  QSG_ADD_TO_HOME_VIEWED: "qsg_add_to_home_viewed",
  QSG_AM_OPTIONS_VIEWED: "qsg_am_options_viewed",
  QSG_AM_VIEWED: "qsg_am_viewed",
  QSG_BUY_BUNDLE_AIRTIME_VIEWED: "qsg_buy_bundle_airtime_viewed",
  QSG_SKIP_CLICKED: "qsg_skip_clicked",
  QSG_FINISH_CLICKED: "qsg_finish_clicked",
  QSG_PREVIOUS_CLICKED: "qsg_previous_clicked"
}


export const LOGIN_EVENTS = {
  login_otp_requestresend: "login_otp_requestresend",
  resend_otp_success: "resend_otp_success",
  resend_otp_failed: "resend_otp_failed",
  login_otp_otpentered: "login_otp_otpentered",
  verify_otp_click: "verify_otp_click",
  login_otp_otpresent: "login_otp_otpresent"
}

export const FORGOT_NUMBER_EVENTS = {
  know_your_number_click: "know_your_number_click",
  pasted_msisdn: "login_msisdn_pasted"
}

export const SECURE_SMS_EVENTS = {
  login_securesms_smsreceived: "login_securesms_smsreceived",
  login_securesms_smscheck_fail_timedout: "login_securesms_smscheck_fail_timedout",
  login_securesms_smscheck_fail_msisdn_mismatch: "login_securesms_smscheck_fail_msisdn_mismatch",
  login_securesms_smscheck_fail_locked: "login_securesms_smscheck_fail_locked",
  login_securesms_smscheck_fail_message_edited: "login_securesms_smscheck_fail_message_edited",
  login_securesms_proceedclicked: "login_securesms_proceedclicked",
  login_securesms_screenviewed: "login_securesms_screenviewed"
}

export const HE_LOGIN_EVENTS = {
  he_login_init: "he_init",
  he_enriched: "he_enriched",
  he_login_wifi_on: "he_error_wifi_on",
  he_login_other_error: "he_error_msisdn_not_enriched",
  he_error_unsupported_browser: "he_error_unsupported_browser",
  he_login_retry: "he_login_retry",
  he_another_method_click: "he_another_method_click",
  he_login_success: "he_success",
  he_error_postpaid: "he_error_postpaid",
  he_failed_device_details: "he_failed_device_details",
  he_failed: "he_failed",
  he_retry_wifi: "he_retry_wifi",
  he_finish: "he_finish",
  he_retry_error_wifi_on: "he_retry_error_wifi_on"
}

export const COMPATIBILITY_EVENTS = {
  compatibility_check_init: "compatibility_check_init",
  compatibility_check_resolution_pass: "compatibility_check_resolution_pass",
  compatibility_check_resolution_fail: "compatibility_check_resolution_fail",
  compatibility_check_browser_pass: "compatibility_check_browser_pass",
  compatibility_check_browser_fail: "compatibility_check_browser_fail",
  compatibility_check_browser_ver_pass: "compatibility_check_browser_ver_pass",
  compatibility_check_browser_ver_fail: "compatibility_check_browser_ver_fail",
  compatibility_check_finish: "compatibility_check_finish",
  compatibility_check_failed: "compatibility_check_failed",
}
export enum EventAction {
  SPLASH_SCREEN_PAGE_VIEW = 'splash_screen_page_view'
}


export const NETWORK_EVENTS = {
  network_type: "network_type",
  network_check_init: "network_check_init",
  network_check_fail: "network_check_fail",
  network_check_finish: "network_check_finish",
}
export const APP_VERSION = "app_version";

export const WITHDRAW_CASH_EVENTS = {
  WITHDRAW_CASH_INIT: "withdraw_cash_init",
  WITHDRAW_CASH_FINISH: "withdraw_cash_finish",
  WITHDRAW_CASH_SUCCESS: "withdraw_cash_success",
  WITHDRAW_CASH_FAILED: "withdraw_cash_failed"
}

export const BUY_GOODS_EVENTS = {
  BUY_GOODS_INIT: "buygoods_init",
  BUY_GOODS_FINISH: "buygoods_finish",
  BUY_GOODS_SUCCESS: "buygoods_success",
  BUY_GOODS_FAILED: "buygoods_failed"
}

export const LOGIN_REASON_CODE_LIST = {
  OTP_SENT: "OTP_SENT",
  SECURE_SMS_TOKEN_SENT: "SECURE_SMS_TOKEN_SENT",
  VERIFY_OTP_SUCCESS: "VERIFY_OTP_SUCCESS",
  VERIFY_OTP_API_FAILED: "VERIFY_OTP_API_FAILED",
  VERFIY_OTP_EXPIRED: "VERFIY_OTP_EXPIRED",
  SMS_MSISDN_VERIFICATION_ERROR: "SMS_MSISDN_VERIFICATION_ERROR",
  NUMBER_SMS_TOKEN_BLOCKED: "NUMBER_SMS_TOKEN_BLOCKED",
  VERIFY_SMS_MSISDN_MISMATCH: "VERIFY_SMS_MSISDN_MISMATCH",
  VERIFY_SMS_TOKEN_VERIFICATION_EXPIRED: "VERIFY_SMS_TOKEN_VERIFICATION_EXPIRED",
  VERIFY_SMS_TOKEN_SUCCESS: "VERIFY_SMS_TOKEN_SUCCESS",
  SEND_OTP_FAIL: "SEND_OTP_FAIL",
  FETCH_SECURE_SMS_TOKEN_FAILED: "FETCH_SECURE_SMS_TOKEN_FAILED",
  HE_LOGIN_FAILED: "HE_LOGIN_FAILED",
  HE_LOGIN_INITIATED: "HE_LOGIN_INITIATED",
  HE_LOGIN_SUCCESS: "HE_LOGIN_SUCCESS"
}

export const LOGIN_REASON_DESC_LIST = {
  HE_LOGIN_INITIATED: "HE Login initiated",
  OTP_SENT_TO_MSISDN: "OTP has been sent to the login msisdn",
  SECURE_SMS_TOKEN_SENT: "Secure sms token has been sent.",
  OTP_SEND_FAILED: "Sending OTP has been failed",
  HE_LOGIN_SUCCESSFUL: "HE Login successful"
}

export const LANGUAGE_EVENTS = {
  LANGUAGE: "language",
  LANGUAGE_HAMBURGUR_MENU_SELECT_LANG_CLICKED: "language_hamburgmenu_selectlang_clicked"
}